import { FC } from 'react'
import Button from '../../../atoms/button/Button'
import Modal from '../Modal'
import './ConfirmModal.scss'

interface Props {
  open: boolean
  title?: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmModal: FC<Props> = ({
  open,
  title = 'Confirm',
  message,
  confirmLabel = 'Yes',
  cancelLabel = 'Cancel',
  loading = false,
  onConfirm,
  onCancel
}) => {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      size="xs"
      body={
        <div className="confirm-modal">
          <div className="confirm-modal__icon">!</div>
          <h3 className="confirm-modal__title">{title}</h3>
          <p className="confirm-modal__message">{message}</p>
          <div className="confirm-modal__actions">
            <Button
              appearance="default"
              className="confirm-modal__btn confirm-modal__btn--cancel"
              onClick={onCancel}
              disabled={loading}
            >
              {cancelLabel}
            </Button>
            <Button
              appearance="primary"
              className="confirm-modal__btn confirm-modal__btn--confirm"
              onClick={onConfirm}
              loading={loading}
            >
              {confirmLabel}
            </Button>
          </div>
        </div>
      }
    />
  )
}

export default ConfirmModal
